<template>

    <Container fluid>

        <Grid>

            <Column class="mb-12">

                <div class="skeleton w-48 h-14"/>

            </Column>

        </Grid>

        <div class="mt-12 space-y-24">

            <OpenSourcePackageSkeleton v-for="rows of 3" :key="rows"/>

        </div>

    </Container>

</template>

<script lang="ts">

    import { defineComponent } from 'vue'
    import Column from './Grid/Column.vue'
    import Grid from './Grid/Grid.vue'
    import Container from './Container.vue'
    import OpenSourcePackageSkeleton from './OpenSourcePackageSkeleton.vue'

    export default defineComponent({
        name: 'OpenSourceSkeleton',
        components: {
            Grid,
            Container,
            Column,
            OpenSourcePackageSkeleton
        }
    })

</script>
